import React from 'react';

import { CarLicensingFields } from './CarLicensingFields';
import { IRelatedInfoFieldsProps, IRelatedInfoHandle, TRelatedInfoKind } from './config';
import { DriverLicensingFields } from './DriverLicensingFields';
import { HomeAddressField } from './HomeAddressField';

const fieldsByKind: Record<
  TRelatedInfoKind,
  React.ForwardRefExoticComponent<IRelatedInfoFieldsProps & React.RefAttributes<IRelatedInfoHandle>>
> = {
  driverLicensing: DriverLicensingFields,
  driverHomeAddress: HomeAddressField,
  carLicensing: CarLicensingFields,
};

interface IProps extends IRelatedInfoFieldsProps {
  kind: TRelatedInfoKind;
}

const UploadRelatedInfo = React.forwardRef<IRelatedInfoHandle, IProps>(({ kind, scope }, ref) => {
  const Fields = fieldsByKind[kind];

  return (
    <div data-test-id="dialog__related-info">
      <Fields ref={ref} scope={scope} />
    </div>
  );
});

UploadRelatedInfo.displayName = 'UploadRelatedInfo';

export { UploadRelatedInfo };
